<template>
  <div class="hint">
    <slot></slot>
  </div>
</template>
<style lang="scss" scoped>
@import "../../../_css/variables.scss";

.hint {
  font-size: 0.75rem;
  color: $gray-600;
}
</style>
